type useIsExampleURLProps = {
  isExampleURL: boolean;
};

export const useIsExampleURL = (): useIsExampleURLProps => {
  const isExampleURL = window.location.pathname.includes(`/example`);
  return { isExampleURL };
};
